import { initializeAlpine } from './alpineInit';
import WidgetRegistrySingleton from "./utils/widgetRegistrySingleton";
import WizardResult from "./widgets/WizardResult";
import ServicePartnerWidget from "./widgets/ServicePartnerPage";
import FindabilityWidget from "./widgets/FindabilityWidget";

initializeAlpine();
const widgetRegistry = WidgetRegistrySingleton.getInstance();
widgetRegistry.registerWidgetClass('WizardResultWidget', WizardResult);
widgetRegistry.registerWidgetClass('FindServicePartnerWidget', ServicePartnerWidget);
widgetRegistry.registerWidgetClass('FindabilityWidget', FindabilityWidget);
widgetRegistry.initializeWidgets();
console.log('Initialized widgets!');
